import React from 'react';
import { useFeature } from 'flagged';
import FeatureFlags from '@/constants/system/FeatureFlags';
import { useQueryProvider } from '@/modules/QueryProvider';
import GroupingType from '../constants/GroupingType';
import type OpportunitiesFilterParams from '../types/OpportunitiesFilterParams';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import GroupedOpportunities from './GroupedOpportunities';
import OpportunitiesDataList from './OpportunitiesDataList';

/**
 * This is a thin wrapper around the data lists on the opportunities page.
 * This wrapper is required so that we can use the query.groupingType from
 * a parent <QueryProvider> rendered higher up on the page.
 */
export default function OpportunitiesPageDataLists() {
  const hasGrouping = useFeature(FeatureFlags.OPPORTUNITIES_GROUPING);
  const { query } = useQueryProvider<OpportunitiesFilterParams>();

  let { groupingType } = query;

  if (!groupingType) {
    groupingType = GroupingType.NONE;
  }

  return (
    <>
      {groupingType === GroupingType.NONE && <OpportunitiesDataList />}

      {hasGrouping && groupingType !== GroupingType.NONE && (
        <GroupedOpportunities type={groupingType} />
      )}
    </>
  );
}
